import React, {Component} from 'react';
import classes from './Layout.css';
import Header from '../../components/Navigation/Toolbar/Toolbar';
import MoveToTopButton from '../../UI/MoveToTopButton/MoveToTopButton';

class Layout extends Component {

    logoutHandler = () => {
        this.props.history.push("/logout");
    }

    render () {
        let form = (
                <div className={classes.Layout}>
                    <div className={classes.HeaderClass}>
                        <Header appName={process.env.REACT_APP_NAME} logout={this.logoutHandler} />
                    </div>
                   
                    <main className={classes.Main}>
                            <div className={classes.ChildClass}>
                                {this.props.children}
                            </div>
                    </main>
                    <MoveToTopButton />
                </div>
            );
        return form;
    }
}

export default Layout;